<template>
  <v-row>
    <v-col cols="12">
      <BaseBlock title="Gestion des formations">
        <v-row v-if="user.roles.indexOf('ROLE_ADMIN') > -1">
          <v-col cols="4" md="4">
            <router-link
              :to="{
                name: 'boAjoutFormation',
              }"
              tag="v-btn"
            >
              <v-icon title="Ajouter une formation">mdi-plus</v-icon>
              Ajouter une formation</router-link
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-data-table
              :headers="headers"
              :items="formations"
              :loading="loading"
              item-key="id"
              class="elevation-1"
              :custom-sort="customSort"
              :search="search"
              :options.sync="options"
            >
              <template v-slot:[`item.eligible`]="{ item }">
                <v-icon v-if="item.eligible == true" class="mr-2"
                  >mdi-check-bold</v-icon
                >
                <v-icon v-else>mdi-close</v-icon>
              </template>
              <template v-slot:[`item.diplome`]="{ item }">
                {{ item.diplome.libelle }}
              </template>
              <template v-slot:[`item.niveau`]="{ item }">
                {{ item.niveau.libelle }}
              </template>
              <template v-slot:[`item.campus`]="{ item }">
                {{ item.campus.libelle }}
              </template>
              <template v-slot:[`item.structure`]="{ item }">
                {{ item.structure.libelle }}
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <router-link
                  :to="{
                    name: 'boEditionFormation',
                    params: { idFormation: item.id },
                  }"
                >
                  <v-icon
                    class="mr-2"
                    title="Editer la formation"
                    color="primary"
                    >mdi-pencil</v-icon
                  >
                </router-link>
                <ActionConfirmation
                  v-if="user.roles.indexOf('ROLE_ADMIN') > -1"
                  icone="mdi-delete"
                  title="Supprimer la formation"
                  @ok="supprimerFormation(item.id)"
                ></ActionConfirmation>
              </template>
              <template v-slot:top>
                <v-row dense>
                  <v-col
                    v-if="niveaux.length > 2 || idNiveau > 0"
                    cols="12"
                    md="2"
                  >
                    <v-select
                      v-model="idNiveau"
                      label="Filtre niveau"
                      :items="niveaux"
                      item-value="id"
                      item-text="libelle"
                      class="mx-5"
                    >
                    </v-select>
                  </v-col>
                  <v-spacer
                    v-if="niveaux.length > 2 || idNiveau > 0"
                  ></v-spacer>
                  <v-col v-if="campus.length > 2" cols="12" md="3">
                    <v-select
                      v-model="idCampus"
                      label="Filtre campus"
                      :items="campus"
                      item-value="id"
                      item-text="libelle"
                      class="mx-3"
                    >
                    </v-select>
                  </v-col>
                  <v-spacer v-if="campus.length > 2"></v-spacer>
                  <v-col cols="12" md="3">
                    <v-select
                      v-model="idStructure"
                      label="Filtre structure"
                      :items="structures"
                      item-value="id"
                      item-text="libelle"
                      class="mx-3"
                    >
                    </v-select>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Recherche"
                      single-line
                      hide-details
                      class="mx-5"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </BaseBlock>
    </v-col>
  </v-row>
</template>
<script>
import BaseBlock from "@/components/base/BaseBlock";
import ActionConfirmation from "@/components/ActionConfirmation";
import ListingSort from "@/js_modules/ListingSort";
import ApiFormationRepository from "@/repositories/ApiFormationRepository";
import { mapState } from "vuex";

export default {
  name: "BOListeFormations",
  components: { BaseBlock, ActionConfirmation },
  data() {
    return {
      loading: false,
      formations: [],
      search: "",
      idCampus: "",
      campus: [],
      idStructure: "",
      structures: [],
      options: {},
      numPage: 1,
      idNiveau: "",
      niveaux: [],
    };
  },
  computed: {
    ...mapState(["user"]),
    headers() {
      return [
        {
          text: "Libellé",
          align: "left",
          sortable: true,
          value: "libelle",
        },
        {
          text: "Eligible",
          align: "center",
          sortable: true,
          value: "eligible",
        },
        {
          text: "Type de diplôme",
          align: "center",
          sortable: true,
          value: "diplome",
        },
        {
          text: "Niveau formation",
          align: "center",
          sortable: true,
          value: "niveau",
          filter: (value) => {
            if (!this.idNiveau) return true;
            return value.id == parseInt(this.idNiveau);
          },
        },
        {
          text: "Campus",
          align: "center",
          sortable: true,
          value: "campus",
          filter: (value) => {
            if (!this.idCampus) return true;
            return value.id == parseInt(this.idCampus);
          },
        },
        {
          text: "Structure",
          align: "center",
          sortable: true,
          value: "structure",
          filter: (value) => {
            if (!this.idStructure) return true;
            return value.id == parseInt(this.idStructure);
          },
        },
        {
          text: "Action",
          align: "center",
          sortable: false,
          value: "action",
        },
      ];
    },
  },
  methods: {
    customSort: function (items, index, isDesc) {
      return ListingSort.sortFormationColumns(items, index, isDesc);
    },
    arrayObjectIndexOf(myArray, searchTerm, property) {
      for (var i = 0, len = myArray.length; i < len; i++) {
        if (myArray[i][property] === searchTerm) return i;
      }
      return -1;
    },
    filterCampus() {
      let filtreCampus = [];
      filtreCampus.push({ id: null, libelle: "" });
      this.formations.forEach((element) => {
        if (
          this.arrayObjectIndexOf(filtreCampus, element.campus.id, "id") === -1
        ) {
          filtreCampus.push({
            id: element.campus.id,
            libelle: element.campus.libelle,
          });
        }
      });
      filtreCampus.sort((a, b) =>
        a.libelle.toLowerCase().localeCompare(b.libelle.toLowerCase())
      );
      return filtreCampus;
    },
    filterStructures() {
      let filtreStructures = [];
      filtreStructures.push({ id: null, libelle: "" });
      this.formations.forEach((element) => {
        if (
          this.arrayObjectIndexOf(
            filtreStructures,
            element.structure.id,
            "id"
          ) === -1
        ) {
          filtreStructures.push({
            id: element.structure.id,
            libelle: element.structure.libelle,
          });
        }
      });
      filtreStructures.sort((a, b) =>
        a.libelle.toLowerCase().localeCompare(b.libelle.toLowerCase())
      );
      return filtreStructures;
    },
    filterNiveaux() {
      let filtreNiveaux = [];
      filtreNiveaux.push({ id: null, libelle: "" });
      this.formations.forEach((element) => {
        if (
          this.arrayObjectIndexOf(filtreNiveaux, element.niveau.id, "id") === -1
        ) {
          filtreNiveaux.push({
            id: element.niveau.id,
            libelle: element.niveau.libelle,
          });
        }
      });
      filtreNiveaux.sort((a, b) => a.id > b.id);
      return filtreNiveaux;
    },
    async getBOFormations() {
      this.loading = true;
      try {
        const boFormations = await ApiFormationRepository.getBOFormations();
        this.formations = boFormations;
        this.campus = this.filterCampus();
        this.structures = this.filterStructures();
        this.niveaux = this.filterNiveaux();
        this.options.page = this.numPage;
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      } finally {
        this.loading = false;
      }
    },
    async supprimerFormation(idFormation) {
      try {
        await ApiFormationRepository.supprimerFormation(idFormation);

        let removeIndex = this.formations
          .map((item) => item.id)
          .indexOf(idFormation);

        this.formations.splice(removeIndex, 1);

        this.$toast.success("La formation a été supprimée");
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      }
    },
  },
  created() {
    if (sessionStorage.bolfidNiveau) {
      if (sessionStorage.bolfidNiveau != 0) {
        this.idNiveau = parseInt(sessionStorage.bolfidNiveau);
      }
    }
    if (sessionStorage.bolfidCampus) {
      if (sessionStorage.bolfidCampus != 0) {
        this.idCampus = parseInt(sessionStorage.bolfidCampus);
      }
    }
    if (sessionStorage.bolfidStructure) {
      if (sessionStorage.bolfidStructure != 0) {
        this.idStructure = parseInt(sessionStorage.bolfidStructure);
      }
    }
    if (sessionStorage.bolfsearch) {
      if (sessionStorage.bolfsearch != "") {
        this.search = sessionStorage.bolfsearch;
      }
    }
    if (sessionStorage.bolfoptions) {
      try {
        this.options = JSON.parse(sessionStorage.getItem("bolfoptions"));
        this.numPage = this.options.page;
      } catch (e) {
        sessionStorage.removeItem("bolfoptions");
      }
    }
    this.getBOFormations();
  },
  watch: {
    idNiveau(id) {
      sessionStorage.bolfidNiveau = id;
    },
    idCampus(id) {
      sessionStorage.bolfidCampus = id;
    },
    idStructure(id) {
      sessionStorage.bolfidStructure = id;
    },
    search(val) {
      sessionStorage.bolfsearch = val;
    },
    options: {
      handler: function () {
        const parsed = JSON.stringify(this.options);
        sessionStorage.setItem("bolfoptions", parsed);
      },
      deep: true,
    },
  },
  mounted() {},
  updated() {},
};
</script>
